<template>
  <div
    class="flex flex-col gap-4 py-[16px]"
    aria-label="모바일 메뉴"
  >
    <!-- 버튼 -->
    <div class="container flex items-center justify-between">
      <router-link
        :to="isMobileApp && isAuthenticated ? '/outbound/app-menu' : '/'"
        @click="toggleMenu('close')"
      >
        <img
          class="logo max-w-[80px]"
          src="@/assets/image/dpost-logo.svg"
          alt="로고"
        />
      </router-link>

      <div class="flex items-center gap-6">
        <div
          v-if="!isAuthenticated"
          class="text-xs items-center"
        >
          <button
            class="flex gap-2"
            @click="
              toggleMenu('close');
              router.push('/signin');
            "
          >
            로그인
            <div class="divide">|</div>
            회원가입
          </button>
        </div>

        <button @click="toggleMenu()">
          <img
            v-if="!isOpen"
            src="@/assets/image/menu.svg"
            alt="메뉴 열기"
          />
          <img
            v-else
            src="@/assets/image/close.svg"
            alt="메뉴 닫기"
          />
        </button>
      </div>
    </div>

    <!-- 메뉴 -->
    <div
      v-if="isOpen"
      class="border-t border-black2 bg-white h-screen overflow-y-auto pb-60"
    >
      <nav
        role="navigation"
        class="container flex flex-col gap-7 py-6"
      >
        <MobileNavigation
          :menu="menu"
          @close-menu="toggleMenu('close')"
        />
        <MobileNavigation
          :menu="mypage"
          @close-menu="toggleMenu('close')"
        />
      </nav>

      <div
        v-if="isAuthenticated"
        class="border-t border-black2 pt-6"
      >
        <div class="container">
          <button
            @click="
              signOut();
              unsetHold();
              isOpen = false;
            "
          >
            로그아웃
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, toRefs, computed } from 'vue';
import { useRouter } from 'vue-router';
import useHold from '@/lib/useHoldScroll';
import MobileNavigation from './MobileNavigation.vue';
import type { Menu } from '@/lib/constants/gnbMenuMap';
import { useClient } from '@/lib/_API/useClient';
import { useMypageStore } from '@/stores/mypage';
const props = defineProps<{
  menu: Menu[];
  mypage: Menu[];
  signOut: () => void;
  isAuthenticated: boolean;
}>();

const router = useRouter();
const { menu, mypage, signOut, isAuthenticated } = toRefs(props);
const { setHold, unsetHold } = useHold();
const { getClientUnitInfo } = useClient();
const mypageStore = useMypageStore();
const isOpen = ref(false);
const isMobileApp = computed(() => {
  const ua = navigator.userAgent || '';
  const hasAgent = /MyAppWebView|ReactNative|wv|Expo/i.test(ua);
  return hasAgent;
});

const toggleMenu = async (command?: string) => {
  //GNB에서는 토글로 메뉴 열고닫으면 안되고, 무조건 열려있을때만 닫혀야해서 close 명령 분리함.
  isOpen.value = command === 'close' ? false : !isOpen.value;
  isOpen.value ? setHold() : unsetHold(); //스크롤 고정

  //모바일 햄버거메뉴 열릴때 로그인유저 권한정보에 따라 - 유닛 하위메뉴 세팅
  if (isOpen.value && isAuthenticated.value) {
    const clientUnitInfo = await getClientUnitInfo();
    mypageStore.updateUnit(clientUnitInfo);
  }
};

onMounted(() => {
  router.beforeEach(async (to, from) => {
    if (isOpen.value) {
      toggleMenu();
    }
  });
});
</script>
<style lang="scss" scoped>
button {
  @apply h-auto bg-transparent;
  color: inherit;
}
</style>
